import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { activeTab: { type: String, default: "overview" } }

  connect() {
    const hash = window.location.hash.replace("#", "")
    if (hash && this.panelTargets.some(p => p.dataset.tab === hash)) {
      this.activeTabValue = hash
    }
    this.showTab(this.activeTabValue)
  }

  switch(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.activeTabValue = tab
    this.showTab(tab)
    window.history.replaceState(null, "", `#${tab}`)
  }

  showTab(tabName) {
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tab === tabName
      tab.classList.toggle("border-emerald-400", isActive)
      tab.classList.toggle("text-emerald-400", isActive)
      tab.classList.toggle("border-transparent", !isActive)
      tab.classList.toggle("text-gray-400", !isActive)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== tabName)
    })
  }
}
